<template>
    <v-row justify="center">
        <v-dialog v-model="showDialog"
                  persistent
                  max-width="600px"
                  overlay-color="#666666"
                  overlay-opacity="0.8">
            <v-card>
                <v-card-title>
                    <span class="headline">Edit Reservoir</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field label="Name*" v-model="current.name" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-select :items="[{ name: 'Public', value: 'public' }, { name: 'Private', value: 'private' }]"
                                          v-model="current.accessType"
                                          label="Access Type*"
                                          item-text="name"
                                          item-value="value"
                                          required
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-select :items="[{ name: 'FIFO', value: 'fifo' }, { name: 'LIFO', value: 'lifo' }]"
                                          v-model="current.accessMethod"
                                          label="Access Method*"
                                          item-text="name"
                                          item-value="value"
                                          required
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-select :items="[{ name: 'Break', value: 'break' },
                                                   { name: 'Pause', value: 'pause' },
                                                   { name: 'Keep Oldest', value: 'old' },
                                                   { name: 'Keep Newest', value: 'new' }]"
                                          v-model="current.overflowStrategy"
                                          label="Overflow Strategy*"
                                          item-text="name"
                                          item-value="value"
                                          required
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field label="Default Expiry (ms)*" v-model="current.defaultExpiryMs" type="number" step="1" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field label="Default Retention (ms)*" v-model="current.defaultRetentionMs" type="number" step="1" required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <small>*indicates required field</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#00AAB9" text @click="showDialog = false">Close</v-btn>
                    <v-btn color="#00AAB9" text @click="saveReservoir()">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import resource from '@/resource';

    export default {
        name: "reservoir-edit",
        props: {
            value: Object,
            show: Boolean
        },
        data() {
            return {
            }
        },
        methods: {
            saveReservoir: function() {
                let newReservoir = {
                    _id: this.current._id,
                    name: this.current.name,
                    accessType: this.current.accessType,
                    accessMethod: this.current.accessMethod,
                    overflowStrategy: this.current.overflowStrategy,
                    defaultExpiryMs: this.current.defaultExpiryMs,
                    defaultRetentionMs: this.current.defaultRetentionMs
                }

                resource.reservoir.updateReservoir(newReservoir).then(res => {
                    if(res.body.status == 'OK') {
                        this.current.updated = true;
                        this.showDialog = false;
                    }
                }, resource.processError);
            }
        },
        computed: {
            showDialog: {
                get() {
                    return this.show
                },
                set (value) {
                    this.$emit('update:show', value);
                }
            },
            current: {
                get() {
                    return this.value
                },
                set (value) {
                    this.$emit('input', value)
                }
            }
        },
        created() {
        }
    }
</script>

<style scoped>

</style>